import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=724f81dc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f81dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724f81dc')) {
      api.createRecord('724f81dc', component.options)
    } else {
      api.reload('724f81dc', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=724f81dc&scoped=true", function () {
      api.rerender('724f81dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/virtualSalesTask/List/Index.vue"
export default component.exports